var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_vm._v("兴趣性格能力测评")]),_c('div',{staticClass:"div",on:{"click":_vm.goevaluation}},[_vm._v("开始测评")])]),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.data.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }